// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3qx9P","ranges":"BmiRanges_ranges__wBl92"};